/* 🤖 this file was generated by svg-to-ts */
export const iconOseth: {
  name: 'oseth';
  data: string;
} = {
  name: 'oseth',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><g clip-path="url(#stakedeth__clip0_298_1031)"><path fill="currentColor" d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0m.21 28.96L5.34 23.41l4.49-8.52 6.39-12.24 6.39 12.24 4.49 8.52-10.87 5.55z"/></g><defs><clipPath id="stakedeth__clip0_298_1031"><path fill="#fff" d="M0 0h32v32H0z"/></clipPath></defs></svg>`,
};
